import { StaffLoginForm } from '@/components/elements/StaffLoginForm';
import { StaffLayout } from '@/components/layouts/StaffLayout';

export const StaffLogin = () => {
  return (
    <StaffLayout showLogout={false}>
      <StaffLoginForm />
    </StaffLayout>
  );
};
